import * as Yup from 'yup'
import { isValidPhoneNumber } from 'react-phone-number-input'
const { object, string } = Yup

Yup.addMethod(string, "validatePhoneNumber", function (errorMessage) {
    return this.test(`test-phone-number`, errorMessage, function (value) {
        if (value) {
            const { path, createError } = this;
            return isValidPhoneNumber(value) || createError({ path, message: errorMessage });
        }
    });
});

const INVALID_PHONE = '*Invalid phone number'

const schema = object().shape({
    companyName: string().required('*Company name  is required'),
    tradingName: string().optional(),
    primaryContactEmail: string().email('*Please write a valid primary contact email').required('*Primary contact email is required'),
    primaryContactPhone: string().required('*Primary contact phone is required').validatePhoneNumber(INVALID_PHONE),
    financeEmail: string().email('*Please write a valid finance email').required('*Finance email is required'),
    financePhone: string().required('*Finance phone is required').validatePhoneNumber(INVALID_PHONE),
    accountsPayableEmail: string().email('*Please write a valid accounts payable email').required('*Accounts payable email is required'),
    companyRegNumber: string().required('*Company reg number is required'),
    firstLine: string().required('*Address line 1 is required'),
    secondLine: string().optional(),
    city: string().required('*City is required'),
    postCode: string().required('*Postal code is required'),
    country: string().required('*Country is required'),
    vatRegNumber: string().required('*VAT number is required'),
})

export default schema
